// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"3447":"150911985f80ceaf","4993":"34196c134f0eeb44"}[chunkId] + ".js";
};